import { TApplicationState } from '../../types/redux';
import { IFormFields } from '../../types/formFields';

export const selectFormFields = (state: TApplicationState): IFormFields => {
  return state.formFields;
};
